import ApiService from "../api";

export default class RomaneioService extends ApiService {

    constructor() {
        super("/api/romaneios");
    }

    importar(data) {
        return this.post(`/upload`, data)
    }

    // Importa em segundo plano; devolve o processo para acompanhar com consultarImportacao
    importarEmSegundoPlano(data) {
        return this.post(`/upload/assincrono`, data)
    }

    consultarImportacao(processoId) {
        return this.get(`/importacoes/${processoId}`)
    }

    listar(funcionarioId, ano, mes, filialId) {
        const params = new URLSearchParams();
        params.append('mes', mes);
        params.append('ano', ano);

        if (funcionarioId) params.append("funcionarioId", funcionarioId)
        if (filialId) params.append("filialId", filialId)

        return this.get(`?${params.toString()}`);
    }

    // Vincula motorista/auxiliares aos romaneios do mesmo período da comissão (ano/mês)
    integrarFuncionarios(ano, mes) {
        const params = new URLSearchParams();
        params.append('ano', ano);
        params.append('mes', mes);

        return this.get(`/integrar-funcionarios?${params.toString()}`);
    }

    calcularTotais(ano, mes) {
        const params = new URLSearchParams();
        params.append('ano', ano);
        params.append('mes', mes);

        return this.get(`/calcular-totais?${params.toString()}`);
    }

    restaurarAjustes(ano, mes) {
        const params = new URLSearchParams();
        params.append('ano', ano);
        params.append('mes', mes);

        return this.get(`/restaurar-ajustes?${params.toString()}`);
    }

    listarOperacoesPorPeriodo(dataInicio, dataFim) {
        return this.get(`/dias-operacao/periodo?inicio=${dataInicio}&fim=${dataFim}`);
    }

    buscarDiasTrabalhados(ano, mes) {
        const params = new URLSearchParams();
        params.append('mes', mes);
        params.append('ano', ano);

        return this.get(`/dias-trabalhados?${params.toString()}`)
    }

    atualizarRomaneio(id, dto) {
        return this.put(`/${id}`, dto);
    }

    listarPedidos(romaneioId) {
        return this.get(`/${romaneioId}/pedidos`);
    }

    listarItensPedido(pedidoId) {
        return this.get(`/pedidos/${pedidoId}/itens`);
    }

    atualizarItemPedido(itemId, dto) {
        return this.patch(`/pedidos/itens/${itemId}`, dto);
    }

}
